import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Directory from "@/pages/Directory";
import ListingDetail from "@/pages/ListingDetail";
import SubmitListing from "@/pages/SubmitListing";
import Advertise from "@/pages/Advertise";
import AdminLogin from "@/admin/AdminLogin";
import OwnerLogin from "@/owner/OwnerLogin";
import OwnerInvite from "@/owner/OwnerInvite";
import OwnerApp from "@/owner/OwnerApp";
import AdminApp from "@/admin/AdminApp";
import PolicyPage from "@/pages/PolicyPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import Impressum from "@/pages/Impressum";
import Contact from "@/pages/Contact";
import { LanguageProvider } from "@/lib/i18n";
import { useState } from "react";
import { api } from "@/lib/api";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SiteLayout() {
  const [countries, setCountries] = useState([]);
  useEffect(() => {
    api.get("/countries").then((r) => setCountries(r.data || [])).catch(() => {});
  }, []);
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer countries={countries} />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
    <BrowserRouter>
      <ScrollToTop />
      <Toaster position="top-center" richColors />
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/directory" element={<Directory />} />
          <Route path="/category/:slug" element={<Directory />} />
          <Route path="/search" element={<Directory />} />
          <Route path="/listing/:slug" element={<ListingDetail />} />
          <Route path="/submit" element={<SubmitListing />} />
          <Route path="/advertise" element={<Advertise />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/terms" element={<Navigate to="/terms-of-service" replace />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/guidelines" element={<PolicyPage kind="guidelines" />} />
          <Route path="/about" element={<PolicyPage kind="about" />} />
        </Route>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/owner/login" element={<OwnerLogin />} />
        <Route path="/owner/invite/:token" element={<OwnerInvite />} />
        <Route path="/owner/*" element={<OwnerApp />} />
        <Route path="/admin/*" element={<AdminApp />} />
      </Routes>
    </BrowserRouter>
    </LanguageProvider>
  );
}
